/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, pool: NonNullable<unknown>, extra: NonNullable<unknown> }} Dashboard_Billing_Headline_TeamInputs */



/**
* | output |
* | --- |
* | "Used {used} of your {pool} pool — {extra} extra usage" |
*
* @param {Dashboard_Billing_Headline_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_headline_team = /** @type {((inputs: Dashboard_Billing_Headline_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Headline_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von Ihrem ${i?.pool} Pool verbraucht — ${i?.extra} Zusatznutzung`)
	return /** @type {LocalizedString} */ (`Used ${i?.used} of your ${i?.pool} pool — ${i?.extra} extra usage`)
});